import { useEffect, useRef, useState } from "react";
import type { CardType } from "../hooks/use-pairs-game";
import Card from "./Card";

type GameBoardProps = {
  cards: CardType[];
  gridSize: number;
  isGameOver: boolean;
  flipCard: (id: number) => void;
};

/**function getMaxPerCard(containerWidth: number, gridSize: number) {
  if (containerWidth <= 1780) {
    if (gridSize > 6) return 83;
    if (gridSize > 4) return 110;
    return 180;
  }

  if (containerWidth < 1920) {
    if (gridSize > 6) return 105;
    if (gridSize > 4) return 120;
    return 170;
  }

  if (containerWidth < 2300) {
    if (gridSize > 6) return 90;
    if (gridSize > 4) return 115;
    return 170;
  }

  if (gridSize > 6) return 120;
  if (gridSize > 4) return 140;
  return 200;
} */

export default function GameBoard({
  cards,
  flipCard,
  gridSize,
  isGameOver,
}: GameBoardProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [_, setContainerWidth] = useState(1024);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const measure = () => {
      // getBoundingClientRect() tends to behave more consistently than contentRect
      // in embedded CEF/Chromium setups.
      setContainerWidth(el.getBoundingClientRect().width);
    };

    measure();

    let ro: ResizeObserver | null = null;
    if ("ResizeObserver" in window) {
      ro = new ResizeObserver(() => measure());
      ro.observe(el);
    }

    // Fallbacks that help in RageMP/CEF where RO can be late or weird
    window.addEventListener("resize", measure);
    const intervalId = window.setInterval(measure, 250);

    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", measure);
      window.clearInterval(intervalId);
    };
  }, []);

  /**  const maxWidth = useMemo(() => {
    const perCard = getMaxPerCard(containerWidth, gridSize);
    return Math.min(gridSize * perCard, containerWidth);
  }, [containerWidth, gridSize]);
 */
  return (
    <div ref={containerRef} className="w-full">
      <div
        className="mx-auto grid gap-2"
        style={{
          // Using minmax(0, 1fr) prevents grid items from forcing tracks wider than expected. [web:5][web:6]
          gridTemplateColumns: `repeat(${gridSize}, minmax(0, 1fr))`,
          //     minWidth: maxWidth,
        }}
      >
        {cards.map((card) => (
          <div
            key={card.id}
            //     style={{ width: getMaxPerCard(containerWidth, gridSize) }}
            className="min-w-0 min-h-0"
          >
            {/* min-w-0 ensures the grid item can shrink instead of expanding the column. [web:10][web:6] */}
            <Card
              gridSize={gridSize}
              isGameOver={isGameOver}
              card={card}
              onClick={flipCard}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
